<template>
  <div>
    <v-card
      elevation="4"
      class="auth-card"
      color="#f7f7fc"
      style="border-radius: 12px"
    >
      <!-- <v-icon @click.stop="signupDialog = false" class="exit">mdi-close</v-icon> -->

      <v-card-text>
        <v-container>
          <form @submit.prevent="onSignup">
            <p
              v-if="fromPage"
              class="text-h5 secondary--text font-weight-bold text-center"
            >
              Sign up to get strapped in!
            </p>
            <h1 v-else-if="addItem" class="secondary--text text-center">
              Sign up to complete your listing!
            </h1>
            <h1 v-else-if="addBooking" class="secondary--text text-center">
              Sign up to complete your booking!
            </h1>
            <div class="my-7 mx-md-12">
              <center>
                <v-btn
                  @click="signInWithGoogle"
                  class="mb-2 text-caption text-md-body-2"
                  elevation="2"
                  color="#34A853"
                  style="border-radius: 8px"
                  outlined
                  block
                  rounded
                  ><img
                    class="mr-2"
                    src="https://img.icons8.com/color/28/000000/google-logo.png"
                  />
                  &nbsp; Google Sign Up</v-btn
                >
                <!-- <v-btn
                  @click="signInWithFacebook"
                  elevation="2"
                  class="mb-2"
                  color="#039BE5"
                  style="border-radius: 8px;"
                  outlined
                  rounded
                  block
                  ><img
                    class="mr-2"
                    src="https://img.icons8.com/color/28/000000/facebook-new.png"
                  />
                  &nbsp; Facebook Sign In</v-btn
                > -->
              </center>
            </div>
            <!-- <div id="firebaseui-auth-container" class="below" /> -->
            <div class="d-flex my-3">
              <v-divider class="my-1"></v-divider>
              <div class="text-overline mx-1 mt-n3">Or Sign Up With</div>
              <v-divider class="my-1"></v-divider>
            </div>
            <p>
              *Please note that your first and last name must be your legitimate
              first name and <strong>must coincide with</strong> the name on
              your ID document.
            </p>

            <v-text-field
              outlined
              block
              id="firstName"
              style="border-radius: 8px"
              v-model="firstName"
              name="first name"
              label="First Name"
              type="name"
              required
            />

            <v-text-field
              outlined
              block
              id="lastName"
              style="border-radius: 8px"
              v-model="lastName"
              name="last Name"
              label="Last Name"
              type="name"
              required
            />

            <v-text-field
              outlined
              id="email"
              v-model="email"
              block
              style="border-radius: 8px"
              label="Email"
              name="email"
              :rules="[rules.min, rules.required, rules.emailRules]"
              type="email"
              required
            />

            <!-- <v-text-field
              outlined
              id="phoneNUmber"
              v-model="phoneNumber"
              block
              name="phone number"
              style="border-radius: 8px"
              label="Phone Number"
              required
            />

            <v-text-field
              outlined
              id="suburb"
              v-model="suburb"
              block
              name="suburb"
              style="border-radius: 8px"
              label="Suburb"
              required
            /> -->

            <v-text-field
              outlined
              block
              id="password"
              v-model="password"
              name="password"
              label="Password"
              required
              style="border-radius: 8px"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required, rules.min]"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
            />

            <!-- <v-text-field
              outlined
              style="border-radius: 8px"
              id="confirmPassword"
              v-model="confirmPassword"
              name="confirmPassword"
              label="Confirm Password"
              block
              :type="show2 ? 'text' : 'password'"
              :rules="[comparePasswords]"
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show2 = !show2"
            /> -->

            <v-row v-if="error">
              <app-alert
                class="ma-6"
                block
                :text="error"
                @dismissed="onDismissed"
              />
            </v-row>

            <div v-if="fromPage">
              Already have an account?
              <div
                style="cursor: pointer"
                class="d-inline-block font-weight-bold accent--text"
                @click="$emit('changeDialog')"
              >
                Login
              </div>
            </div>
            <div v-else>
              Already have an account?
              <div
                style="cursor: pointer"
                class="d-inline-block font-weight-bold accent--text mb-1"
                @click="$emit('changeDialog')"
              >
                Login
              </div>
              <span v-if="addItem"> to complete your listing</span>
              <span v-else-if="addBooking"> to complete your booking</span>
            </div>

            <v-row>
              <p @click.stop="" class="mt-3 caption">
                By selecting <strong>Agree and continue </strong>below I
                acknowledge that i have read and agree with
                <router-link target="_blank" to="terms">
                  Strapps terms and conditions
                </router-link>
                and
                <router-link target="_blank" to="privacy-policy"
                  >Privacy policy</router-link
                >
              </p>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-btn
                  type="submit"
                  rel="noopener"
                  target="_blank"
                  color="accent"
                  class="mb-3 sign-button"
                  block
                  :loading="loading"
                  large
                  style="
                    background-image: linear-gradient(
                      to right,
                      #a18cd1 0%,
                      #b22af0 100%
                    );
                  "
                  :disabled="!formIsValid"
                >
                  Agree and continue
                </v-btn>
              </v-col>
            </v-row>
          </form>
        </v-container>
      </v-card-text>
    </v-card>

    <v-dialog
      style="border-radius: 12px !important"
      v-model="welcomeDialog"
      width="500"
    >
      <v-card style="border-radius: 12px !important" class="text-center">
        <v-card-title
          style="
            padding: 0px 24px !important;
            font-size: 1em !important;
            line-height: 1.43;
          "
          class="text-center black--text"
        >
          <!-- <v-icon small color="black" @click="welcomeDialog = false"
            >mdi-close</v-icon
          > -->
          <p class="my-3 ml-auto mr-auto">Get Started</p>
        </v-card-title>
        <v-divider></v-divider>

        <base-img
          :src="require('@/assets/logos/icon1.svg')"
          class="mb-5 mt-15 mx-auto"
          contain
          height="100"
          width="382"
        />

        <p class="heading my-3 ml-auto mr-auto">Welcome to Strapp</p>
        <v-card-text
          style="
            font-size: 16px !important;
            line-height: 20px !important;
            color: rgb(34, 34, 34) !important;
          "
        >
          Experience new ways of participating with your community
        </v-card-text>
        <!-- <v-card-text>
          Users will not be able to see your photo until a booking has been
          made.
        </v-card-text> -->

        <!-- <v-divider></v-divider> -->

        <v-card-actions>
          <v-btn
            v-if="addItem"
            block
            class="btn white--text"
            style="border-radius: 8px !important"
            @click="welcomeDialog = false"
            color="black"
            :disabled="loading || !formIsValid"
          >
            Finish Submitting Item
          </v-btn>

          <v-btn
            v-else
            block
            class="btn white--text"
            style="border-radius: 8px !important"
            @click="(verifyDialog = true), (startDialog = false)"
            color="black"
            :disabled="loading || !formIsValid"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import VueTelInputVuetify from "vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue";
import firebase from "firebase/compat/app";
// import { auth, functions } from './../../main.js'

export default {
  name: "Signup",
  components: {},
  props: {
    gradient: {
      type: String,
      default: "to top, rgba(0,0,0,.18), rgba(0,0,0,.18)",
    },
    shouldRedirect: {
      type: Boolean,
      default: true,
    },
    addItem: {
      type: Boolean,
      default: true,
    },
    addBooking: {
      type: Boolean,
      default: true,
    },
    fromPage: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      show1: false,
      show2: false,
      welcomeDialog: false,
      email: "",
      password: "",
      firstName: "",
      lastName: "",
      phoneNumber: "",
      suburb: "",
      terms: "false",
      confirmPassword: "",
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
        emailMatch: () => "The email and password you entered don't match",
        //email validation
        emailRules: (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      },
    };
  },
  computed: {
    formIsValid() {
      return (
        this.firstName !== "" &&
        this.lastName !== "" &&
        this.email !== "" &&
        this.password.length >= 8
      );
    },
    // comparePasswords() {
    //   return this.password !== this.confirmPassword
    //     ? "Passwords do not match"
    //     : true;
    // },
    user() {
      return this.$store.getters.user;
    },
    error() {
      return this.$store.getters.error;
    },
    loading() {
      return this.$store.getters.loading;
    },
  },
  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        if (this.shouldRedirect) {
          this.$router.push("/dashboard");
          this.$emit("loggedIn");
        } else if (this.addItem || this.addBooking) {
          this.$emit("loggedIn");
        } else {
          this.$emit("loggedIn");
        }
      }
    },
  },

  // mounted() {
  //   var uiConfig = {
  //     signInSuccessUrl: "/",
  //     signInOptions: [
  //       firebase.auth.GoogleAuthProvider.PROVIDER_ID,
  //       firebase.auth.FacebookAuthProvider.PROVIDER_ID
  //     ]
  //   };
  //   let ui = firebaseui.auth.AuthUI.getInstance();
  //   if (!ui) {
  //     ui = new firebaseui.auth.AuthUI(firebase.auth());
  //   }
  //   ui.start("#firebaseui-auth-container", uiConfig);
  // },
  created() {
    this.$store.commit("setLoading", false);
    this.$store.dispatch("clearError");
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
      }
    });
  },
  methods: {
    // signInWithGoogle() {
    //   this.$store.dispatch("signInWithGoogle");
    // },
    signInWithGoogle({ dispatch }) {
      //clear errror
      this.$store.dispatch("clearError");
      const provider = new firebase.auth.GoogleAuthProvider();
      return firebase
        .auth()
        .signInWithPopup(provider)
        .then((data) => {
          console.log("g sign up data", data);
          const user = data.user;
          firebase
            .firestore()
            .collection("users")
            .doc(user.uid)
            .set({
              id: user.uid,
              // email: user.email,
              // username: user.email,
              firstName: user.displayName.split(" ").slice(0, -1).join(" "),
              createdAt: new Date(),
              avatar: user.photoURL,
              verified: false,
            })
            .then(
              firebase
                .firestore()
                .collection("users")
                .doc(user.uid)
                .collection("privateData")
                .doc(user.uid)
                .set({
                  termsAndPrivacyPolicy: "true",
                  firstName: user.displayName.split(" ").slice(0, -1).join(" "),
                  lastName: user.displayName.split(" ").slice(-1).join(" "),
                  createdAt: new Date(),
                  name: user.displayName,
                  email: user.email,
                })
            )
            .then(
              firebase
                .firestore()
                .collection("crmData")
                .doc(user.uid)
                .set({
                  id: user.uid,
                  email: user.email,
                  username: user.email,
                  createdAt: new Date(),
                  firstName: user.displayName.split(" ").slice(0, -1).join(" "),
                  avatar: user.photoURL,
                  verified: false,
                })
            );

          console.log("g sign up");
        });
    },

    fetchAuthUser({ dispatch, commit }) {
      console.log("fetch auth user");
      const userId = firebase.auth().currentUser.uid;
      return new Promise((resolve, reject) => {
        // check if user exists in the database
        firebase
          .database()
          .ref("users")
          .child(userId)
          .once("value", (snapshot) => {
            if (snapshot.exists()) {
              return dispatch(
                "users/fetchUser",
                { id: userId },
                { root: true }
              ).then((user) => {
                commit("setAuthId", userId);
                resolve(user);
              });
            } else {
              resolve(null);
            }
          });
      });
    },
    // signInWithGoogle() {
    //   const provider = new firebase.auth.GoogleAuthProvider();
    //   firebase
    //     .auth()
    //     .signInWithPopup(provider)
    //     .catch(error => alert("🤕" + error.message))
    //     .then(data => console.log(data.user, data.credential.accessToken))
    //     .then(cred => {
    //       return firebase
    //         .firestore()
    //         .collection("users")
    //         .doc(cred.user.uid)
    //         .set({
    //           uid: user.uid,
    //           email: user.email,
    //           displayName: user.displayName,
    //           photoURL: user.photoURL
    //         })
    //         .then(
    //           firebase
    //             .firestore()
    //             .collection("users")
    //             .doc(cred.user.uid)
    //             .collection("privateData")
    //             .doc(cred.user.uid)
    //             .set({
    //               termsAndPrivacyPolicy: "true",
    //               firstName: user.getDisplayName(),
    //               displayName: user.displayName,
    //               lastName: user.getDisplayName(),
    //               email: user.email
    //             })
    //         )
    //         .then(
    //           firebase
    //             .firestore()
    //             .collection("crmData")
    //             .doc(cred.user.uid)
    //             .set({
    //               firstName: user.getDisplayName(),
    //               lastName: user.getDisplayName(),
    //               email: auth.currentUser.email
    //             })padd
    //         );
    //     });
    //   onCreateItem();
    // },
    signInWithFacebook() {
      var provider = new firebase.auth.FacebookAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        .catch((error) => alert("🤕" + error.message))
        .then((data) => console.log(data.user, data.credential.accessToken));
      onCreateItem();
    },

    onSignup() {
      this.$store.dispatch("clearError");
      console.log("Manual Sign up");
      this.$store.dispatch("signUserUp", {
        email: this.email,
        password: this.password,
        // phoneNumber: this.phoneNumber,
        firstName: this.firstName,
        lastName: this.lastName,
        // suburb: this.suburb,
      });
      // console.log({ email: this.email, password: this.password, confirmPassword: this.confirmPassword })
    },
    onDismissed() {
      this.$store.dispatch("clearError");
    },
  },
};
</script>

<style scoped>
.exit {
  position: absolute !important;
  display: flex !important;
  top: 16px !important;
  left: 24px !important;
  z-index: 1 !important;
}
.auth-card {
  width: 100% !important;
  max-width: 568px !important;
  border-radius: 18px !important;
}

.centered {
  position: fixed;
  top: 22%;
  left: 50%;
  /* bring your own prefixes */
  transform: translate(-50%, -50%);
}

.sign-button {
  padding: 1rem 4rem;
  border-radius: 8px;
  font-weight: 700;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
}

.sign-button:hover {
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
}
</style>
